import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useCourse(data = {}) {
  const { enabled = false, configs = {}, courseID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getCourse() {
    return privateFetch.get(`/v1/admin/course/${courseID}`, configs).then((res) => res.data);
  }

  return useQuery(['courses', courseID, { data }], getCourse, { enabled });
}

export default useCourse;
